export const mapData =[
    [
        "Lat",
        "Lon",
        "Name",
        ""
    ],
    [
        24.0734356,
        75.0679018,
        "Mandsaur",
        1
    ],
    [
        12.5218157,
        76.89514880000002,
        "Mandya",
        1
    ],
    [
        21.9279896,
        86.7630057,
        "Mayurbhanj",
        1
    ],
    [
        30.7046486,
        76.71787259999999,
        "Mohali",
        1
    ],
    [
        28.9844618,
        77.7064137,
        "Meerut",
        1
    ],
    [
        22.4256613,
        87.3198819,
        "Medinipur",
        1
    ],
    [
        22.5978545,
        80.3713531,
        "Mandla",
        1
    ],
    [
        30.8230114,
        75.17344709999999,
        "Moga",
        1
    ],
    [
        26.3210313,
        94.5147156,
        "Mokokchung",
        1
    ],
    [
        18.0462192,
        78.2631756,
        "Medak",
        1
    ],
    [
        28.8386481,
        78.7733286,
        "Moradabad",
        1
    ],
    [
        29.9995069,
        75.3936808,
        "Mansa",
        1
    ],
    [
        26.2514394,
        92.342311,
        "Marigaon",
        1
    ],
    [
        27.4924134,
        77.673673,
        "Mathura",
        1
    ],
    [
        19.0759837,
        72.8776559,
        "Mumbai",
        1
    ],
    [
        21.1458004,
        79.0881546,
        "Nagpur",
        1
    ],
    [
        26.4446185,
        91.4410527,
        "Nalbari",
        1
    ],
    [
        31.1255583,
        76.118642,
        "Nawanshahr",
        1
    ],
    [
        12.2958104,
        76.6393805,
        "Mysore",
        1
    ],
    [
        11.2193848,
        78.16784179999999,
        "Namakkal",
        1
    ],
    [
        20.1231332,
        85.1038426,
        "Nayagarh",
        1
    ],
    [
        19.6765668,
        78.53208409999999,
        "Adilabad",
        1
    ],
    [
        27.1766701,
        78.00807449999999,
        "Agra",
        1
    ],
    [
        19.0948287,
        74.74797889999999,
        "Ahmed Nagar",
        1
    ],
    [
        23.022505,
        72.5713621,
        "Ahmedabad",
        1
    ],
    [
        23.7307175,
        92.71731059999999,
        "Aizawl",
        1
    ],
    [
        26.4498954,
        74.6399163,
        "Ajmer",
        1
    ],
    [
        20.7002159,
        77.0081678,
        "Akola",
        1
    ],
    [
        9.498066699999999,
        76.3388484,
        "Alappuzha",
        1
    ],
    [
        19.1485289,
        77.3191471,
        "Nanded",
        1
    ],
    [
        27.8973944,
        78.0880129,
        "Aligarh",
        1
    ],
    [
        22.3059709,
        74.35581479999999,
        "Alirajpur",
        1
    ],
    [
        25.4358011,
        81.846311,
        "Allahabad",
        1
    ],
    [
        29.5892407,
        79.646666,
        "Almora",
        1
    ],
    [
        27.5529907,
        76.6345735,
        "Alwar",
        1
    ],
    [
        19.9974533,
        73.78980229999999,
        "Nashik",
        1
    ],
    [
        30.3752011,
        76.782122,
        "Ambala",
        1
    ],
    [
        26.3745075,
        82.6915429,
        "Ambedkar Nagar",
        1
    ],
    [
        20.9319821,
        77.7523039,
        "Amravati",
        1
    ],
    [
        30.4761773,
        74.5121599,
        "Muktsar",
        1
    ],
    [
        21.6015242,
        71.2203555,
        "Amreli",
        1
    ],
    [
        31.6339793,
        74.8722642,
        "Amritsar",
        1
    ],
    [
        14.6818877,
        77.6005911,
        "Ananthapur",
        1
    ],
    [
        20.8444033,
        85.1510818,
        "Angul",
        1
    ],
    [
        23.1148065,
        81.6987997,
        "Anuppur",
        1
    ],
    [
        26.1324689,
        87.4528067,
        "Araria",
        1
    ],
    [
        11.1403677,
        79.07445,
        "Ariyalur",
        1
    ],
    [
        25.2427603,
        84.6655981,
        "Arwal",
        1
    ],
    [
        24.5775148,
        77.7318495,
        "Ashok Nagar",
        1
    ],
    [
        26.4605377,
        79.5112528,
        "Auraiya",
        1
    ],
    [
        19.8761653,
        75.3433139,
        "Aurangabad",
        1
    ],
    [
        24.7486689,
        84.3807025,
        "Aurangabad(BH)",
        1
    ],
    [
        26.0739138,
        83.18594949999999,
        "Azamgarh",
        1
    ],
    [
        16.1691096,
        75.6615029,
        "Bagalkot",
        1
    ],
    [
        29.8403606,
        79.769426,
        "Bageshwar",
        1
    ],
    [
        28.9427827,
        77.22760699999999,
        "Bagpat",
        1
    ],
    [
        27.5705152,
        81.59766719999999,
        "Bahraich",
        1
    ],
    [
        21.812876,
        80.18382930000001,
        "Balaghat",
        1
    ],
    [
        20.7011108,
        83.4846069,
        "Balangir",
        1
    ],
    [
        21.4933578,
        86.9134794,
        "Baleswar",
        1
    ],
    [
        25.763119,
        84.14962200000001,
        "Ballia",
        1
    ],
    [
        27.4307473,
        82.1805203,
        "Balrampur",
        1
    ],
    [
        24.3070289,
        72.3514618,
        "Banaskantha",
        1
    ],
    [
        25.4520223,
        80.54384499999999,
        "Banda",
        1
    ],
    [
        11.6676783,
        76.632607,
        "Bandipur",
        1
    ],
    [
        12.9715987,
        77.5945627,
        "Bangalore",
        1
    ],
    [
        13.1535064,
        77.8524505,
        "Bangalore Rural",
        1
    ],
    [
        23.2312686,
        87.07838749999999,
        "Bankura",
        1
    ],
    [
        23.5461394,
        74.4349761,
        "Banswara",
        1
    ],
    [
        26.9268042,
        81.1833809,
        "Barabanki",
        1
    ],
    [
        34.1990498,
        74.3499496,
        "Baramulla",
        1
    ],
    [
        25.1012882,
        76.5119321,
        "Baran",
        1
    ],
    [
        23.2324214,
        87.8614793,
        "Bardhaman",
        1
    ],
    [
        28.3670355,
        79.4304381,
        "Bareilly",
        1
    ],
    [
        21.3470154,
        83.6320212,
        "Bargarh",
        1
    ],
    [
        25.7521467,
        71.3966865,
        "Barmer",
        1
    ],
    [
        30.3819446,
        75.5467979,
        "Barnala",
        1
    ],
    [
        26.3304209,
        91.0040547,
        "Barpeta",
        1
    ],
    [
        22.0363157,
        74.903339,
        "Barwani",
        1
    ],
    [
        19.1071317,
        81.9534815,
        "Bastar",
        1
    ],
    [
        30.210994,
        74.9454745,
        "Bathinda",
        1
    ],
    [
        18.990088,
        75.7531324,
        "Beed",
        1
    ],
    [
        25.4181638,
        86.1271542,
        "Begusarai",
        1
    ],
    [
        15.8496953,
        74.4976741,
        "Belgaum",
        1
    ],
    [
        15.1393932,
        76.9214428,
        "Bellary",
        1
    ],
    [
        21.9011601,
        77.8960201,
        "Betul",
        1
    ],
    [
        21.0573616,
        86.4962996,
        "Bhadrak",
        1
    ],
    [
        25.242453,
        86.9842256,
        "Bhagalpur",
        1
    ],
    [
        21.177658,
        79.6570127,
        "Bhandara",
        1
    ],
    [
        27.2151863,
        77.5029996,
        "Bharatpur",
        1
    ],
    [
        21.7051358,
        72.9958748,
        "Bharuch",
        1
    ],
    [
        21.7644725,
        72.15193040000001,
        "Bhavnagar",
        1
    ],
    [
        25.3407388,
        74.63131829999999,
        "Bhilwara",
        1
    ],
    [
        26.5637768,
        78.78609159999999,
        "Bhind",
        1
    ],
    [
        28.7974684,
        76.1322058,
        "Bhiwani",
        1
    ],
    [
        25.466155,
        84.5222189,
        "Bhojpur",
        1
    ],
    [
        23.2599333,
        77.412615,
        "Bhopal",
        1
    ],
    [
        17.9103939,
        77.51990789999999,
        "Bidar",
        1
    ],
    [
        16.8301708,
        75.710031,
        "Bijapur(CGH)",
        1
    ],
    [
        16.8301708,
        75.710031,
        "Bijapur(KAR)",
        1
    ],
    [
        29.3731673,
        78.1350904,
        "Bijnor",
        1
    ],
    [
        28.0229348,
        73.3119159,
        "Bikaner",
        1
    ],
    [
        31.3406931,
        76.6874701,
        "Bilaspur (HP)",
        1
    ],
    [
        22.0796545,
        82.1409152,
        "Bilaspur(CGH)",
        1
    ],
    [
        24.3587525,
        87.8402888,
        "Birbhum",
        1
    ],
    [
        23.067179,
        87.32146809999999,
        "Bishnupur",
        1
    ],
    [
        23.6692956,
        86.15111200000001,
        "Bokaro",
        1
    ],
    [
        26.5030072,
        90.5535724,
        "Bongaigaon",
        1
    ],
    [
        20.8418205,
        84.3200184,
        "Boudh",
        1
    ],
    [
        28.0311101,
        79.1271229,
        "Budaun",
        1
    ],
    [
        33.9348549,
        74.64004320000001,
        "Budgam",
        1
    ],
    [
        28.406963,
        77.8498292,
        "Bulandshahr",
        1
    ],
    [
        20.5292147,
        76.1841701,
        "Buldhana",
        1
    ],
    [
        25.4325869,
        75.6482726,
        "Bundi",
        1
    ],
    [
        21.3145021,
        76.2180095,
        "Burhanpur",
        1
    ],
    [
        25.5647103,
        83.9777482,
        "Buxar",
        1
    ],
    [
        24.7821253,
        92.8577105,
        "Cachar",
        1
    ],
    [
        28.6814551,
        77.22279,
        "Central Delhi",
        1
    ],
    [
        32.5533633,
        76.1258083,
        "Chamba",
        1
    ],
    [
        30.4554245,
        79.87448359999999,
        "Chamoli",
        1
    ],
    [
        29.3360974,
        80.0910275,
        "Champawat",
        1
    ],
    [
        23.4775158,
        93.3236697,
        "Champhai",
        1
    ],
    [
        11.9261471,
        76.9437312,
        "Chamrajnagar",
        1
    ],
    [
        25.2604696,
        83.264538,
        "Chandauli",
        1
    ],
    [
        24.3320104,
        94.00072540000001,
        "Chandel",
        1
    ],
    [
        30.7333148,
        76.7794179,
        "Chandigarh",
        1
    ],
    [
        19.9615398,
        79.2961468,
        "Chandrapur",
        1
    ],
    [
        27.1355348,
        95.73644170000001,
        "Changlang",
        1
    ],
    [
        24.206475,
        84.8718433,
        "Chatra",
        1
    ],
    [
        18.6725047,
        78.09408669999999,
        "Nizamabad",
        1
    ],
    [
        13.0843007,
        80.2704622,
        "Chennai",
        1
    ],
    [
        24.9167821,
        79.5910058,
        "Chhatarpur",
        1
    ],
    [
        22.057437,
        78.9381729,
        "Chhindwara",
        1
    ],
    [
        13.3161441,
        75.7720439,
        "Chickmagalur",
        1
    ],
    [
        13.4354985,
        77.7315344,
        "Chikkaballapur",
        1
    ],
    [
        14.2250932,
        76.3980464,
        "Chitradurga",
        1
    ],
    [
        25.1788154,
        80.86545339999999,
        "Chitrakoot",
        1
    ],
    [
        13.217176,
        79.1003289,
        "Chittoor",
        1
    ],
    [
        24.8829177,
        74.6229699,
        "Chittorgarh",
        1
    ],
    [
        24.3460416,
        93.6999733,
        "Churachandpur",
        1
    ],
    [
        28.2925364,
        74.9707262,
        "Churu",
        1
    ],
    [
        11.0168445,
        76.9558321,
        "Coimbatore",
        1
    ],
    [
        26.3452397,
        89.4482079,
        "Cooch Behar",
        1
    ],
    [
        11.7480419,
        79.7713687,
        "Cuddalore",
        1
    ],
    [
        11.4916043,
        76.7336521,
        "Nilgiris",
        1
    ],
    [
        14.4673154,
        78.8242089,
        "Cuddapah",
        1
    ],
    [
        20.462521,
        85.8829895,
        "Cuttack",
        1
    ],
    [
        22.8344992,
        74.26061849999999,
        "Dahod",
        1
    ],
    [
        12.8437814,
        75.2479061,
        "Dakshina Kannada",
        1
    ],
    [
        20.3973736,
        72.8327991,
        "Daman",
        1
    ],
    [
        23.8323022,
        79.4386591,
        "Damoh",
        1
    ],
    [
        18.8998486,
        81.34743,
        "Dantewada",
        1
    ],
    [
        26.1542045,
        85.8918454,
        "Darbhanga",
        1
    ],
    [
        27.0416208,
        88.2664124,
        "Darjiling",
        1
    ],
    [
        26.4511588,
        92.1057549,
        "Darrang",
        1
    ],
    [
        25.6653168,
        78.4609182,
        "Datia",
        1
    ],
    [
        26.8996953,
        76.332411,
        "Dausa",
        1
    ],
    [
        14.4644085,
        75.921758,
        "Davangere",
        1
    ],
    [
        21.5383136,
        84.7289442,
        "Debagarh",
        1
    ],
    [
        30.3164945,
        78.03219179999999,
        "Dehradun",
        1
    ],
    [
        24.485179,
        86.694785,
        "Deoghar",
        1
    ],
    [
        26.5024286,
        83.7791283,
        "Deoria",
        1
    ],
    [
        22.9675929,
        76.0534454,
        "Dewas",
        1
    ],
    [
        23.8466982,
        91.9099238,
        "Dhalai",
        1
    ],
    [
        20.7101344,
        81.5489077,
        "Dhamtari",
        1
    ],
    [
        23.7956531,
        86.43038589999999,
        "Dhanbad",
        1
    ],
    [
        22.4959294,
        75.1545381,
        "Dhar",
        1
    ],
    [
        15.4589236,
        75.007808,
        "Dharwad",
        1
    ],
    [
        27.4720412,
        94.5587757,
        "Dhemaji",
        1
    ],
    [
        20.6504753,
        85.5981223,
        "Dhenkanal",
        1
    ],
    [
        26.6965521,
        77.8907576,
        "Dholpur",
        1
    ],
    [
        26.0206982,
        89.9743463,
        "Dhubri",
        1
    ],
    [
        20.9042201,
        74.7748979,
        "Dhule",
        1
    ],
    [
        28.7312796,
        95.89871389999999,
        "Dibang Valley",
        1
    ],
    [
        27.4705449,
        94.91246249999999,
        "Dibrugarh",
        1
    ],
    [
        25.9091406,
        93.72656049999999,
        "Dimapur",
        1
    ],
    [
        10.3623794,
        77.9694579,
        "Dindigul",
        1
    ],
    [
        22.9417931,
        81.07684549999999,
        "Dindori",
        1
    ],
    [
        33.1457497,
        75.5480491,
        "Doda",
        1
    ],
    [
        24.2684794,
        87.24880879999999,
        "Dumka",
        1
    ],
    [
        23.8518813,
        73.72043049999999,
        "Dungarpur",
        1
    ],
    [
        21.1904494,
        81.2849169,
        "Durg",
        1
    ],
    [
        26.6098139,
        84.8567932,
        "East Champaran",
        1
    ],
    [
        28.6273231,
        77.3007143,
        "East Delhi",
        1
    ],
    [
        25.5671692,
        90.52578229999999,
        "East Garo Hills",
        1
    ],
    [
        17.32125,
        82.0407137,
        "East Godavari",
        1
    ],
    [
        27.6141916,
        92.8577105,
        "East Kameng",
        1
    ],
    [
        25.3681768,
        91.7538817,
        "East Khasi Hills",
        1
    ],
    [
        21.9372879,
        87.77633329999999,
        "East Midnapore",
        1
    ],
    [
        21.8802526,
        76.64127119999999,
        "East Nimar",
        1
    ],
    [
        28.0550482,
        95.35208759999999,
        "East Siang",
        1
    ],
    [
        27.3083637,
        88.6723578,
        "East Sikkim",
        1
    ],
    [
        22.4866756,
        86.49965460000001,
        "East Singhbhum",
        1
    ],
    [
        9.9816358,
        76.2998842,
        "Ernakulam",
        1
    ],
    [
        11.3410364,
        77.7171642,
        "Erode",
        1
    ],
    [
        27.5625106,
        78.6654148,
        "Etah",
        1
    ],
    [
        26.7829103,
        79.027659,
        "Etawah",
        1
    ],
    [
        26.7729751,
        82.1457934,
        "Faizabad",
        1
    ],
    [
        28.4089123,
        77.3177894,
        "Faridabad",
        1
    ],
    [
        30.6774058,
        74.7539266,
        "Faridkot",
        1
    ],
    [
        27.3825853,
        79.5840195,
        "Farrukhabad",
        1
    ],
    [
        29.5131814,
        75.4509532,
        "Fatehabad",
        1
    ],
    [
        30.6435345,
        76.39703,
        "Fatehgarh Sahib",
        1
    ],
    [
        25.9209503,
        80.7996035,
        "Fatehpur",
        1
    ],
    [
        30.4036478,
        74.0279621,
        "Fazilka",
        1
    ],
    [
        27.1591961,
        78.3957331,
        "Firozabad",
        1
    ],
    [
        30.9331348,
        74.6224755,
        "Firozpur",
        1
    ],
    [
        15.4315406,
        75.63551489999999,
        "Gadag",
        1
    ],
    [
        20.184871,
        79.9947956,
        "Gadchiroli",
        1
    ],
    [
        19.1912221,
        84.1857115,
        "Gajapati",
        1
    ],
    [
        23.2156354,
        72.63694149999999,
        "Gandhi Nagar",
        1
    ],
    [
        25.2621826,
        85.47880649999999,
        "Nalanda",
        1
    ],
    [
        29.9093759,
        73.87998050000002,
        "Ganganagar",
        1
    ],
    [
        19.3871214,
        85.05233559999999,
        "Ganjam",
        1
    ],
    [
        24.1548982,
        83.7995617,
        "Garhwa",
        1
    ],
    [
        20.6347897,
        82.0614974,
        "Gariaband",
        1
    ],
    [
        28.358983,
        77.55076199999999,
        "Gautam Buddha Nagar",
        1
    ],
    [
        24.7913957,
        85.0002336,
        "Gaya",
        1
    ],
    [
        28.6691565,
        77.45375779999999,
        "Ghaziabad",
        1
    ],
    [
        25.5877901,
        83.5783078,
        "Ghazipur",
        1
    ],
    [
        24.19135,
        86.2996368,
        "Giridh",
        1
    ],
    [
        26.1639014,
        90.6253459,
        "Goalpara",
        1
    ],
    [
        24.8255215,
        87.2135177,
        "Godda",
        1
    ],
    [
        26.5238515,
        93.96233699999999,
        "Golaghat",
        1
    ],
    [
        27.1339874,
        81.96189790000001,
        "Gonda",
        1
    ],
    [
        21.4549477,
        80.19607119999999,
        "Gondia",
        1
    ],
    [
        26.4605776,
        84.44024619999999,
        "Gopalganj",
        1
    ],
    [
        26.7605545,
        83.3731675,
        "Gorakhpur",
        1
    ],
    [
        17.329731,
        76.8342957,
        "Gulbarga",
        1
    ],
    [
        23.0441295,
        84.53794549999999,
        "Gumla",
        1
    ],
    [
        24.6323648,
        77.3001762,
        "Guna",
        1
    ],
    [
        16.3066525,
        80.4365402,
        "Guntur",
        1
    ],
    [
        32.0413917,
        75.403086,
        "Gurdaspur",
        1
    ],
    [
        28.4594965,
        77.0266383,
        "Gurgaon",
        1
    ],
    [
        26.2124007,
        78.1772053,
        "Gwalior",
        1
    ],
    [
        24.680855,
        92.56480950000001,
        "Hailakandi",
        1
    ],
    [
        31.6861745,
        76.52130919999999,
        "Hamirpur",
        1
    ],
    [
        31.6861745,
        76.52130919999999,
        "Hamirpur(HP)",
        1
    ],
    [
        29.5821848,
        74.3292106,
        "Hanumangarh",
        1
    ],
    [
        22.3466702,
        77.0889583,
        "Harda",
        1
    ],
    [
        27.3965071,
        80.1250479,
        "Hardoi",
        1
    ],
    [
        29.9456906,
        78.16424780000001,
        "Haridwar",
        1
    ],
    [
        13.0033234,
        76.1003894,
        "Hassan",
        1
    ],
    [
        27.5980718,
        78.0492265,
        "Hathras",
        1
    ],
    [
        14.7950698,
        75.39906739999999,
        "Haveri",
        1
    ],
    [
        23.9924669,
        85.3636758,
        "Hazaribag",
        1
    ],
    [
        19.7114963,
        77.1453846,
        "Hingoli",
        1
    ],
    [
        29.1491875,
        75.7216527,
        "Hisar",
        1
    ],
    [
        22.9011588,
        88.3898552,
        "Hooghly",
        1
    ],
    [
        22.7518961,
        77.7288655,
        "Hoshangabad",
        1
    ],
    [
        31.5143178,
        75.911483,
        "Hoshiarpur",
        1
    ],
    [
        22.5957689,
        88.26363940000002,
        "Howrah",
        1
    ],
    [
        17.406498,
        78.47724389999999,
        "Hyderabad",
        1
    ],
    [
        9.9188973,
        77.10249019999999,
        "Idukki",
        1
    ],
    [
        24.8027256,
        94.028678,
        "Imphal East",
        1
    ],
    [
        24.7827837,
        93.88589549999999,
        "Imphal West",
        1
    ],
    [
        22.7195687,
        75.8577258,
        "Indore",
        1
    ],
    [
        23.1685786,
        79.9338798,
        "Jabalpur",
        1
    ],
    [
        20.2548998,
        86.1706221,
        "Jagatsinghapur",
        1
    ],
    [
        25.5488415,
        92.38136209999999,
        "Jaintia Hills",
        1
    ],
    [
        26.9124336,
        75.7872709,
        "Jaipur",
        1
    ],
    [
        26.9157487,
        70.9083443,
        "Jaisalmer",
        1
    ],
    [
        20.8341019,
        86.3326058,
        "Jajapur",
        1
    ],
    [
        31.3260152,
        75.57618289999999,
        "Jalandhar",
        1
    ],
    [
        26.1458649,
        79.3296565,
        "Jalaun",
        1
    ],
    [
        21.0076578,
        75.5626039,
        "Jalgaon",
        1
    ],
    [
        19.8346659,
        75.88163449999999,
        "Jalna",
        1
    ],
    [
        25.3474783,
        72.6226296,
        "Jalor",
        1
    ],
    [
        26.5214579,
        88.7195567,
        "Jalpaiguri",
        1
    ],
    [
        32.7266016,
        74.8570259,
        "Jammu",
        1
    ],
    [
        22.4707019,
        70.05773,
        "Jamnagar",
        1
    ],
    [
        23.9612357,
        86.80480179999999,
        "Jamtara",
        1
    ],
    [
        24.9255887,
        86.2258592,
        "Jamui",
        1
    ],
    [
        21.9705529,
        82.4752757,
        "Janjgir-champa",
        1
    ],
    [
        22.8759331,
        84.1381159,
        "Jashpur",
        1
    ],
    [
        25.7464145,
        82.68370329999999,
        "Jaunpur",
        1
    ],
    [
        25.2132649,
        84.9853322,
        "Jehanabad",
        1
    ],
    [
        22.769666,
        74.5920921,
        "Jhabua",
        1
    ],
    [
        28.6054875,
        76.6537749,
        "Jhajjar",
        1
    ],
    [
        24.593906,
        76.1642846,
        "Jhalawar",
        1
    ],
    [
        25.4484257,
        78.5684594,
        "Jhansi",
        1
    ],
    [
        21.8554375,
        84.0061661,
        "Jharsuguda",
        1
    ],
    [
        28.1317038,
        75.4022233,
        "Jhujhunu",
        1
    ],
    [
        29.325508,
        76.29979089999999,
        "Jind",
        1
    ],
    [
        26.2389469,
        73.02430939999999,
        "Jodhpur",
        1
    ],
    [
        26.7509207,
        94.2036696,
        "Jorhat",
        1
    ],
    [
        21.5222203,
        70.4579436,
        "Junagadh",
        1
    ],
    [
        28.8635062,
        78.3387066,
        "Jyotiba Phule Nagar",
        1
    ],
    [
        17.1999602,
        78.5505481,
        "K.V.Rangareddy",
        1
    ],
    [
        23.7337326,
        69.8597406,
        "Kachchh",
        1
    ],
    [
        25.0426227,
        83.6055732,
        "Kaimur (Bhabua)",
        1
    ],
    [
        29.8042758,
        76.4039016,
        "Kaithal",
        1
    ],
    [
        19.9137363,
        83.1649001,
        "Kalahandi",
        1
    ],
    [
        25.9410942,
        91.28910359999999,
        "Kamrup",
        1
    ],
    [
        12.8372508,
        79.7041749,
        "Kanchipuram",
        1
    ],
    [
        20.1342042,
        84.01674229999999,
        "Kandhamal",
        1
    ],
    [
        32.1014764,
        76.2731465,
        "Kangra",
        1
    ],
    [
        20.2616974,
        81.38393260000001,
        "Kanker",
        1
    ],
    [
        27.0514156,
        79.9136731,
        "Kannauj",
        1
    ],
    [
        11.8744775,
        75.37036619999999,
        "Kannur",
        1
    ],
    [
        26.526707,
        79.8296743,
        "Kanpur Dehat",
        1
    ],
    [
        26.4148245,
        80.23213129999999,
        "Kanpur Nagar",
        1
    ],
    [
        8.0843512,
        77.54950190000001,
        "Kanyakumari",
        1
    ],
    [
        31.3722571,
        75.4017654,
        "Kapurthala",
        1
    ],
    [
        10.9254398,
        79.8380056,
        "Karaikal",
        1
    ],
    [
        26.186085,
        93.5812692,
        "Karbi Anglong",
        1
    ],
    [
        34.5538522,
        76.1348944,
        "Kargil",
        1
    ],
    [
        29.4726817,
        77.7085091,
        "Muzaffarnagar",
        1
    ],
    [
        18.4385553,
        79.1288412,
        "Karim Nagar",
        1
    ],
    [
        24.8649128,
        92.3591531,
        "Karimganj",
        1
    ],
    [
        29.6856929,
        76.9904825,
        "Karnal",
        1
    ],
    [
        10.9600778,
        78.07660360000001,
        "Karur",
        1
    ],
    [
        12.4995966,
        74.9869276,
        "Kasargod",
        1
    ],
    [
        32.3863082,
        75.5173465,
        "Kathua",
        1
    ],
    [
        25.5540648,
        87.5591073,
        "Katihar",
        1
    ],
    [
        23.8343441,
        80.38938139999999,
        "Katni",
        1
    ],
    [
        25.361054,
        81.40317069999999,
        "Kaushambi",
        1
    ],
    [
        22.0106092,
        81.23592819999999,
        "Kawardha",
        1
    ],
    [
        21.628933,
        85.5816847,
        "Kendujhar",
        1
    ],
    [
        25.50452,
        86.47014159999999,
        "Khagaria",
        1
    ],
    [
        17.2472528,
        80.1514447,
        "Khammam",
        1
    ],
    [
        21.8314037,
        76.3497612,
        "Khandwa",
        1
    ],
    [
        21.8257464,
        75.61840610000002,
        "Khargone",
        1
    ],
    [
        22.750651,
        72.68466579999999,
        "Kheda",
        1
    ],
    [
        27.9462395,
        80.7787163,
        "Kheri",
        1
    ],
    [
        20.1862584,
        85.62227419999999,
        "Khorda",
        1
    ],
    [
        23.0797595,
        85.2774207,
        "Khunti",
        1
    ],
    [
        31.65095759999999,
        78.4751945,
        "Kinnaur",
        1
    ],
    [
        25.8683014,
        94.7857071,
        "Kiphire",
        1
    ],
    [
        26.0982167,
        87.9450379,
        "Kishanganj",
        1
    ],
    [
        12.3374942,
        75.8069082,
        "Kodagu",
        1
    ],
    [
        24.4676805,
        85.59336449999999,
        "Koderma",
        1
    ],
    [
        25.6751129,
        94.10859980000001,
        "Kohima",
        1
    ],
    [
        26.4021196,
        90.27056789999999,
        "Kokrajhar",
        1
    ],
    [
        13.1362143,
        78.12909859999999,
        "Kolar",
        1
    ],
    [
        24.2252057,
        92.6777587,
        "Kolasib",
        1
    ],
    [
        16.7049873,
        74.24325270000001,
        "Kolhapur",
        1
    ],
    [
        22.5743545,
        88.3628734,
        "Kolkata",
        1
    ],
    [
        8.8932118,
        76.6141396,
        "Kollam",
        1
    ],
    [
        15.3504652,
        76.1567298,
        "Koppal",
        1
    ],
    [
        18.813487,
        82.71233269999999,
        "Koraput",
        1
    ],
    [
        22.3594501,
        82.75005949999999,
        "Korba",
        1
    ],
    [
        23.3875499,
        82.38857829999999,
        "Koriya",
        1
    ],
    [
        22.710047,
        88.7108964,
        "North 24 Parganas",
        1
    ],
    [
        25.2138156,
        75.8647527,
        "Kota",
        1
    ],
    [
        9.591566799999999,
        76.5221531,
        "Kottayam",
        1
    ],
    [
        11.2587531,
        75.78041,
        "Kozhikode",
        1
    ],
    [
        12.5265661,
        78.2149575,
        "Krishnagiri",
        1
    ],
    [
        33.6449908,
        75.018031,
        "Kulgam",
        1
    ],
    [
        31.959205,
        77.1089377,
        "Kullu",
        1
    ],
    [
        34.5261786,
        74.2546136,
        "Kupwara",
        1
    ],
    [
        15.8281257,
        78.0372792,
        "Kurnool",
        1
    ],
    [
        29.9695121,
        76.878282,
        "Kurukshetra",
        1
    ],
    [
        28.073758,
        93.2583626,
        "Kurung Kumey",
        1
    ],
    [
        26.7398787,
        83.8869698,
        "Kushinagar",
        1
    ],
    [
        32.6192107,
        77.3783789,
        "Lahul & Spiti",
        1
    ],
    [
        27.9462395,
        80.7787163,
        "Lakhimpur",
        1
    ],
    [
        25.1571454,
        86.0951592,
        "Lakhisarai",
        1
    ],
    [
        9.985089192440064,
        72.93247324992308,
        "Lakshadweep",
        1
    ],
    [
        24.6911707,
        78.4138183,
        "Lalitpur",
        1
    ],
    [
        23.7463215,
        84.5091102,
        "Latehar",
        1
    ],
    [
        18.4087934,
        76.5603828,
        "Latur",
        1
    ],
    [
        22.5320875,
        92.8990711,
        "Lawngtlai",
        1
    ],
    [
        34.1525864,
        77.57705349999999,
        "Leh",
        1
    ],
    [
        23.4415776,
        84.6869722,
        "Lohardaga",
        1
    ],
    [
        28.0682343,
        96.15269850000001,
        "Lohit",
        1
    ],
    [
        26.4876945,
        94.8165389,
        "Longleng",
        1
    ],
    [
        28.0829633,
        95.81428849999999,
        "Lower Dibang Valley",
        1
    ],
    [
        27.5910076,
        93.8248241,
        "Lower Subansiri",
        1
    ],
    [
        26.8466937,
        80.94616599999999,
        "Lucknow",
        1
    ],
    [
        30.900965,
        75.8572758,
        "Ludhiana",
        1
    ],
    [
        22.8889908,
        92.74554289999999,
        "Lunglei",
        1
    ],
    [
        25.9239677,
        86.7946387,
        "Madhepura",
        1
    ],
    [
        26.3482938,
        86.0711661,
        "Madhubani",
        1
    ],
    [
        9.9252007,
        78.1197754,
        "Madurai",
        1
    ],
    [
        16.7488379,
        78.00351719999999,
        "Mahabub Nagar",
        1
    ],
    [
        27.1446035,
        83.5621737,
        "Maharajganj",
        1
    ],
    [
        21.1124067,
        82.09596200000001,
        "Mahasamund",
        1
    ],
    [
        28.2734201,
        76.14013489999999,
        "Mahendragarh",
        1
    ],
    [
        23.5879607,
        72.36932519999999,
        "Mahesana",
        1
    ],
    [
        25.2945119,
        79.8858951,
        "Mahoba",
        1
    ],
    [
        27.2281937,
        79.02516589999999,
        "Mainpuri",
        1
    ],
    [
        11.0509762,
        76.0710967,
        "Malappuram",
        1
    ],
    [
        25.0108408,
        88.14109669999999,
        "Malda",
        1
    ],
    [
        18.3435863,
        81.88252790000001,
        "Malkangiri",
        1
    ],
    [
        31.5892006,
        76.91820969999999,
        "Mandi",
        1
    ],
    [
        22.9473179,
        79.1923266,
        "Narsinghpur",
        1
    ],
    [
        29.3924139,
        79.4533773,
        "Nainital",
        1
    ],
    [
        14.4425987,
        79.98645599999999,
        "Nellore",
        1
    ],
    [
        19.7195568,
        81.2471973,
        "Narayanpur",
        1
    ],
    [
        21.3700906,
        74.240336,
        "Nandurbar",
        1
    ],
    [
        27.1983368,
        73.7493272,
        "Nagaur",
        1
    ],
    [
        26.348009,
        92.6838111,
        "Nagaon",
        1
    ],
    [
        24.1759039,
        88.2801785,
        "Murshidabad",
        1
    ],
    [
        10.7672313,
        79.8448512,
        "Nagapattinam",
        1
    ],
    [
        17.0577054,
        79.26836229999999,
        "Nalgonda",
        1
    ],
    [
        24.0797139,
        92.2630393,
        "North Tripura",
        1
    ],
    [
        24.8866859,
        85.54345719999999,
        "Nawada",
        1
    ],
    [
        24.4737663,
        74.8726497,
        "Neemuch",
        1
    ],
    [
        25.9810393,
        88.050979,
        "North Dinajpur",
        1
    ],
    [
        20.9467019,
        72.95203479999999,
        "Navsari",
        1
    ],
    [
        25.3707993,
        86.47339029999999,
        "Munger",
        1
    ],
    [
        26.1196607,
        85.390982,
        "Muzaffarpur",
        1
    ],
    [
        28.6139298,
        77.2088282,
        "New Delhi",
        1
    ],
    [
        15.5163112,
        73.98300290000002,
        "North Goa",
        1
    ],
    [
        28.7484441,
        77.14390999999999,
        "North Delhi",
        1
    ],
    [
        25.3478004,
        93.0175712,
        "North Cachar Hills",
        1
    ],
    [
        27.8236356,
        88.55653099999999,
        "North Sikkim",
        1
    ],
    [
        23.4709656,
        88.55653099999999,
        "Nadia",
        1
    ],
    [
        12.5601347,
        92.8976254,
        "North And Middle Andaman",
        1
    ],
    [
        19.2277163,
        82.5490885,
        "Nabarangapur",
        1
    ],
    [
        28.7196003,
        77.0684107,
        "North West Delhi",
        1
    ],
    [
        28.7246777,
        77.2577571,
        "North East Delhi",
        1
    ],
    [
        18.185332,
        76.0419642,
        "Osmanabad",
        1
    ],
    [
        18.5204303,
        73.8567437,
        "Pune",
        1
    ],
    [
        25.7780623,
        73.331147,
        "Pali",
        1
    ],
    [
        20.8060184,
        82.5361393,
        "Nuapada",
        1
    ],
    [
        30.6942091,
        76.860565,
        "Panchkula",
        1
    ],
    [
        19.2608384,
        76.774776,
        "Parbhani",
        1
    ],
    [
        23.8409874,
        84.1012861,
        "Palamau",
        1
    ],
    [
        27.2240654,
        93.5003454,
        "Papum Pare",
        1
    ],
    [
        10.3832867,
        78.800129,
        "Pudukkottai",
        1
    ],
    [
        10.7867303,
        76.6547932,
        "Palakkad",
        1
    ],
    [
        9.2647582,
        76.78704139999999,
        "Pathanamthitta",
        1
    ],
    [
        23.8500156,
        72.1210274,
        "Patan",
        1
    ],
    [
        24.4892018,
        80.1875065,
        "Panna",
        1
    ],
    [
        33.76700140000001,
        74.0924041,
        "Poonch",
        1
    ],
    [
        29.3909464,
        76.9635023,
        "Panipat",
        1
    ],
    [
        24.6336908,
        87.8500644,
        "Pakur",
        1
    ],
    [
        16.216018,
        77.3565608,
        "Raichur",
        1
    ],
    [
        28.62494,
        79.8075272,
        "Pilibhit",
        1
    ],
    [
        29.5828604,
        80.2181884,
        "Pithoragarh",
        1
    ],
    [
        33.8716117,
        74.89456919999999,
        "Pulwama",
        1
    ],
    [
        25.6645749,
        94.4695358,
        "Phek",
        1
    ],
    [
        11.9415915,
        79.8083133,
        "Pondicherry",
        1
    ],
    [
        19.8134554,
        85.8312359,
        "Puri",
        1
    ],
    [
        21.8974003,
        83.39496319999999,
        "Raigarh",
        1
    ],
    [
        30.3397809,
        76.3868797,
        "Patiala",
        1
    ],
    [
        25.7771391,
        87.4752551,
        "Purnia",
        1
    ],
    [
        11.2342104,
        78.8806852,
        "Perambalur",
        1
    ],
    [
        26.2144806,
        81.25281389999999,
        "Raebareli",
        1
    ],
    [
        25.8973038,
        81.9452981,
        "Pratapgarh",
        1
    ],
    [
        30.1471155,
        78.7745393,
        "Pauri Garhwal",
        1
    ],
    [
        22.8011177,
        73.55941279999999,
        "Panch Mahals",
        1
    ],
    [
        23.3322026,
        86.3616405,
        "Puruliya",
        1
    ],
    [
        15.348463,
        79.560344,
        "Prakasam",
        1
    ],
    [
        21.2513844,
        81.62964130000002,
        "Raipur",
        1
    ],
    [
        21.6416979,
        69.62930589999999,
        "Porbandar",
        1
    ],
    [
        18.5157519,
        73.1821623,
        "Raigarh(MH)",
        1
    ],
    [
        32.2733352,
        75.6522066,
        "Pathankot",
        1
    ],
    [
        25.5940947,
        85.1375645,
        "Patna",
        1
    ],
    [
        33.3716143,
        74.315191,
        "Rajauri",
        1
    ],
    [
        24.0078819,
        76.7278803,
        "Rajgarh",
        1
    ],
    [
        23.3327329,
        77.7823973,
        "Raisen",
        1
    ],
    [
        23.3440997,
        85.309562,
        "Ranchi",
        1
    ],
    [
        25.0583257,
        73.88600339999999,
        "Rajsamand",
        1
    ],
    [
        21.0976046,
        81.0337066,
        "Rajnandgaon",
        1
    ],
    [
        23.6362593,
        85.5124209,
        "Ramgarh",
        1
    ],
    [
        22.3038945,
        70.80215989999999,
        "Rajkot",
        1
    ],
    [
        31.104963,
        77.1639874,
        "Shimla",
        1
    ],
    [
        28.798299,
        79.02202869999999,
        "Rampur",
        1
    ],
    [
        25.8560271,
        85.7868233,
        "Samastipur",
        1
    ],
    [
        12.7208614,
        77.27989629999999,
        "Ramanagar",
        1
    ],
    [
        23.300232,
        81.3568619,
        "Shahdol",
        1
    ],
    [
        23.311308,
        92.8564098,
        "Serchhip",
        1
    ],
    [
        29.9680035,
        77.55520659999999,
        "Saharanpur",
        1
    ],
    [
        9.3639356,
        78.8394819,
        "Ramanathapuram",
        1
    ],
    [
        33.0803564,
        74.83644129999999,
        "Reasi",
        1
    ],
    [
        23.2032399,
        77.0844044,
        "Sehore",
        1
    ],
    [
        28.1919738,
        76.6190774,
        "Rewari",
        1
    ],
    [
        26.989087,
        94.63942399999999,
        "Sibsagar",
        1
    ],
    [
        23.4225728,
        76.2871419,
        "Shajapur",
        1
    ],
    [
        30.9661003,
        76.5230961,
        "Rupnagar",
        1
    ],
    [
        26.5145872,
        85.29423129999999,
        "Sheohar",
        1
    ],
    [
        25.67282,
        76.6961305,
        "Sheopur",
        1
    ],
    [
        30.9661003,
        76.5230961,
        "Ropar",
        1
    ],
    [
        23.8476704,
        72.99329689999999,
        "Sabarkantha",
        1
    ],
    [
        21.4668716,
        83.9811665,
        "Sambalpur",
        1
    ],
    [
        27.2990659,
        83.0927827,
        "Siddharthnagar",
        1
    ],
    [
        22.8561261,
        86.0121573,
        "Seraikela-kharsawan",
        1
    ],
    [
        28.8955152,
        76.606611,
        "Rohtak",
        1
    ],
    [
        27.5035427,
        82.036461,
        "Shrawasti",
        1
    ],
    [
        25.7765249,
        84.7380858,
        "Saran",
        1
    ],
    [
        16.8523973,
        74.5814773,
        "Sangli",
        1
    ],
    [
        23.3315103,
        75.0366677,
        "Ratlam",
        1
    ],
    [
        24.6287405,
        83.92016559999999,
        "Rohtas",
        1
    ],
    [
        22.0868691,
        79.5434841,
        "Seoni",
        1
    ],
    [
        13.9299299,
        75.568101,
        "Shimoga",
        1
    ],
    [
        11.664325,
        78.1460142,
        "Salem",
        1
    ],
    [
        25.2381216,
        87.64535920000002,
        "Sahibganj",
        1
    ],
    [
        25.8773651,
        86.5927887,
        "Saharsa",
        1
    ],
    [
        27.8753399,
        79.9147268,
        "Shahjahanpur",
        1
    ],
    [
        23.838805,
        78.7378068,
        "Sagar",
        1
    ],
    [
        26.012373,
        76.3560109,
        "Sawai Madhopur",
        1
    ],
    [
        25.1391653,
        85.83921509999999,
        "Sheikhpura",
        1
    ],
    [
        24.6005075,
        80.8322428,
        "Satna",
        1
    ],
    [
        19.1714939,
        83.4116756,
        "Rayagada",
        1
    ],
    [
        25.4320478,
        77.66438149999999,
        "Shivpuri",
        1
    ],
    [
        16.990215,
        73.31202329999999,
        "Ratnagiri",
        1
    ],
    [
        25.326373,
        82.4319405,
        "Sant Ravidas Nagar",
        1
    ],
    [
        17.6804639,
        74.018261,
        "Satara",
        1
    ],
    [
        30.2850407,
        78.98219399999999,
        "Rudraprayag",
        1
    ],
    [
        24.5362477,
        81.30369460000001,
        "Rewa",
        1
    ],
    [
        26.7671755,
        83.03613759999999,
        "Sant Kabir Nagar",
        1
    ],
    [
        33.7170033,
        74.83609179999999,
        "Shopian",
        1
    ],
    [
        30.2457963,
        75.8420716,
        "Sangrur",
        1
    ],
    [
        25.9321374,
        92.0665197,
        "Ri Bhoi",
        1
    ],
    [
        22.4889619,
        92.97697060000002,
        "Saiha",
        1
    ],
    [
        25.2729769,
        94.0266087,
        "Senapati",
        1
    ],
    [
        27.6093912,
        75.1397935,
        "Sikar",
        1
    ],
    [
        26.2243204,
        84.3599953,
        "Siwan",
        1
    ],
    [
        16.1668396,
        73.55941279999999,
        "Sindhudurg",
        1
    ],
    [
        30.9084245,
        77.09990309999999,
        "Solan",
        1
    ],
    [
        24.8827147,
        72.8608948,
        "Sirohi",
        1
    ],
    [
        24.1989544,
        82.6676209,
        "Singrauli",
        1
    ],
    [
        24.6850005,
        83.0683519,
        "Sonbhadra",
        1
    ],
    [
        24.3956038,
        81.88252790000001,
        "Sidhi",
        1
    ],
    [
        29.5320731,
        75.03177339999999,
        "Sirsa",
        1
    ],
    [
        22.6133396,
        84.5018278,
        "Simdega",
        1
    ],
    [
        30.5628455,
        77.4701972,
        "Sirmaur",
        1
    ],
    [
        26.6769864,
        92.6983868,
        "Sonitpur",
        1
    ],
    [
        26.5886976,
        85.5012971,
        "Sitamarhi",
        1
    ],
    [
        17.6599188,
        75.9063906,
        "Solapur",
        1
    ],
    [
        27.5680156,
        80.6789519,
        "Sitapur",
        1
    ],
    [
        26.1172425,
        91.98020129999999,
        "Sonapur",
        1
    ],
    [
        28.99308229999999,
        77.0150735,
        "Sonipat",
        1
    ],
    [
        9.8479616,
        78.4832344,
        "Sivaganga",
        1
    ],
    [
        22.120021,
        84.037224,
        "Sundergarh",
        1
    ],
    [
        23.2317493,
        91.55961169999999,
        "South Tripura",
        1
    ],
    [
        21.1702401,
        72.83106070000001,
        "Surat",
        1
    ],
    [
        25.3715308,
        88.55653099999999,
        "South Dinajpur",
        1
    ],
    [
        34.0836708,
        74.7972825,
        "Srinagar",
        1
    ],
    [
        27.5860574,
        91.8594062,
        "Tawang",
        1
    ],
    [
        19.2183307,
        72.9780897,
        "Thane",
        1
    ],
    [
        26.2585371,
        82.06598579999999,
        "Sultanpur",
        1
    ],
    [
        22.7251204,
        71.63695419999999,
        "Surendra Nagar",
        1
    ],
    [
        24.9897661,
        93.5011835,
        "Tamenglong",
        1
    ],
    [
        18.2949165,
        83.89380179999999,
        "Srikakulam",
        1
    ],
    [
        10.7869994,
        79.13782739999999,
        "Thanjavur",
        1
    ],
    [
        22.9494079,
        83.1649001,
        "Surguja",
        1
    ],
    [
        28.4929198,
        77.1847921,
        "South Delhi",
        1
    ],
    [
        10.7448873,
        92.49999179999999,
        "South Andaman",
        1
    ],
    [
        22.1366735,
        88.55653099999999,
        "South 24 Parganas",
        1
    ],
    [
        26.1233718,
        86.6045134,
        "Supaul",
        1
    ],
    [
        31.4538668,
        74.9267599,
        "Tarn Taran",
        1
    ],
    [
        10.0079322,
        77.4735441,
        "Theni",
        1
    ],
    [
        15.11766,
        74.12399599999999,
        "South Goa",
        1
    ],
    [
        30.3825777,
        78.4737736,
        "Tehri Garhwal",
        1
    ],
    [
        25.3300969,
        90.563609,
        "South Garo Hills",
        1
    ],
    [
        20.8253781,
        73.7007088,
        "The Dangs",
        1
    ],
    [
        27.305098,
        88.362785,
        "South Sikkim",
        1
    ],
    [
        28.6134377,
        76.9800824,
        "South West Delhi",
        1
    ],
    [
        24.7456147,
        78.8320779,
        "Tikamgarh",
        1
    ],
    [
        24.6415766,
        93.9991818,
        "Thoubal",
        1
    ],
    [
        23.5235719,
        77.81397179999999,
        "Vidisha",
        1
    ],
    [
        10.5276416,
        76.2144349,
        "Thrissur",
        1
    ],
    [
        8.5241391,
        76.9366376,
        "Thiruvananthapuram",
        1
    ],
    [
        9.5680116,
        77.96244349999999,
        "Virudhunagar",
        1
    ],
    [
        32.9159847,
        75.1416173,
        "Udhampur",
        1
    ],
    [
        12.2252841,
        79.07469569999999,
        "Tiruvannamalai",
        1
    ],
    [
        25.6838206,
        85.35496499999999,
        "Vaishali",
        1
    ],
    [
        28.3348801,
        93.9878427,
        "Upper Subansiri",
        1
    ],
    [
        23.5309797,
        80.82947469999999,
        "Umaria",
        1
    ],
    [
        26.5393449,
        80.4878195,
        "Unnao",
        1
    ],
    [
        25.3176452,
        82.9739144,
        "Varanasi",
        1
    ],
    [
        25.0967563,
        94.3617273,
        "Ukhrul",
        1
    ],
    [
        22.3071588,
        73.1812187,
        "Vadodara",
        1
    ],
    [
        28.86128979999999,
        94.976654,
        "Upper Siang",
        1
    ],
    [
        26.234793,
        94.811956,
        "Tuensang",
        1
    ],
    [
        10.7904833,
        78.7046725,
        "Tiruchirappalli",
        1
    ],
    [
        13.3408807,
        74.7421427,
        "Udupi",
        1
    ],
    [
        27.0185604,
        95.51973939999999,
        "Tirap",
        1
    ],
    [
        12.9165167,
        79.13249859999999,
        "Vellore",
        1
    ],
    [
        18.1066576,
        83.39555059999999,
        "Vizianagaram",
        1
    ],
    [
        11.9401378,
        79.4861449,
        "Villupuram",
        1
    ],
    [
        24.585445,
        73.712479,
        "Udaipur",
        1
    ],
    [
        14.7937065,
        74.6868815,
        "Uttara Kannada",
        1
    ],
    [
        20.5992349,
        72.9342451,
        "Valsad",
        1
    ],
    [
        23.1764665,
        75.7885163,
        "Ujjain",
        1
    ],
    [
        13.3378762,
        77.117325,
        "Tumkur",
        1
    ],
    [
        8.715017999999999,
        77.765628,
        "Tirunelveli",
        1
    ],
    [
        13.1230558,
        79.9119526,
        "Tiruvallur",
        1
    ],
    [
        10.7661312,
        79.6343691,
        "Tiruvarur",
        1
    ],
    [
        17.6868159,
        83.2184815,
        "Visakhapatnam",
        1
    ],
    [
        31.4684649,
        76.2708152,
        "Una",
        1
    ],
    [
        30.7268307,
        78.4354042,
        "Uttarkashi",
        1
    ],
    [
        27.4885539,
        95.355758,
        "Tinsukia",
        1
    ],
    [
        8.764166099999999,
        78.1348361,
        "Tuticorin",
        1
    ],
    [
        26.1659063,
        75.7962852,
        "Tonk",
        1
    ],
    [
        28.9609653,
        79.5153773,
        "Udham Singh Nagar",
        1
    ],
    [
        20.745319,
        78.60219459999999,
        "Wardha",
        1
    ],
    [
        11.703206,
        76.0833999,
        "Wayanad",
        1
    ],
    [
        17.9692624,
        79.59263039999999,
        "Warangal",
        1
    ],
    [
        27.1543104,
        84.3542049,
        "West Champaran",
        1
    ],
    [
        28.1782689,
        94.5211935,
        "West Siang",
        1
    ],
    [
        23.899682,
        91.4048249,
        "West Tripura",
        1
    ],
    [
        22.5045936,
        87.460397,
        "West Midnapore",
        1
    ],
    [
        27.3427633,
        92.30244599999999,
        "West Kameng",
        1
    ],
    [
        20.111238,
        77.13030789999999,
        "Washim",
        1
    ],
    [
        20.3899385,
        78.1306846,
        "Yavatmal",
        1
    ],
    [
        16.7625516,
        77.1442251,
        "Yadgir",
        1
    ],
    [
        26.0128579,
        94.5241504,
        "Zunhebotto",
        1
    ],
    [
        26.1023895,
        94.2522438,
        "Wokha",
        1
    ],
    [
        22.3650858,
        85.4375574,
        "West Singhbhum",
        1
    ],
    [
        25.7573475,
        90.2244662,
        "West Garo Hills",
        1
    ],
    [
        16.9174181,
        81.3399414,
        "West Godavari",
        1
    ],
    [
        30.1290485,
        77.2673901,
        "Yamuna Nagar",
        1
    ],
    [
        21.90287,
        75.8069082,
        "West Nimar",
        1
    ],
    [
        28.6580724,
        77.06402299999999,
        "West Delhi",
        1
    ],
    [
        25.5624625,
        91.28910359999999,
        "West Khasi Hills",
        1
    ],
    [
        27.3031986,
        88.2071598,
        "West Sikkim",
        1
    ],
    [
        26.5049791,
        77.0267705,
        "Karauli",
        1
    ],
    [
        12.1210997,
        78.1582143,
        "Dharmapuri",
        1
    ],
    [
        20.5035436,
        86.4199321,
        "Kendrapara",
        1
    ],
    [
        22.564518,
        72.928871,
        "Anand",
        1
    ],
    [
        33.72979,
        75.15033,
        "Ananthnag",
        1
    ],
    [
        24.885483,
        86.920731,
        "Banka",
        1
    ],
    [
        26.7800781,
        82.7641135,
        "Basti",
        1
    ],
    [
        20.1809,
        73.0169,
        "Dadra and Nagar Haveli",
        1
    ],
    [
        20.718472557827027,
        70.9860479802744,
        "Diu",
        1
    ],
    [
        16.58829436503162,
        80.86888807059292,
        "Krishna",
        1
    ],
    [
        11.700287392114392,
        75.53440498619482,
        "Mahe",
        1
    ],
    [
        23.9280252315519,
        92.4911848227966,
        "Mamit",
        1
    ],
    [
        25.948898555253866,
        83.55911952510911,
        "Mau",
        1
    ],
    [
        25.140745475788954,
        82.56223144681823,
        "Mirzapur",
        1
    ],
    [
        26.688121007301834,
        95.0199682169082,
        "Mon",
        1
    ],
    [
        26.60488328695666,
        77.98263664314537,
        "Morena",
        1
    ],
    [
        21.681777739847327,
        73.64819224638124,
        "Narmada",
        1
    ],
    [
        6.985324071362977,
        93.82014525497158,
        "Nicobar",
        1
    ],
    [
        25.537904274306143,
        93.73290641499723,
        "Peren",
        1
    ],
    [
        21.202916905734543,
        73.44354302665147,
        "Tapi",
        1
    ]
]

